module.exports = __webpack_public_path__ + "img/servicios2.fa8ffae4.png";